var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BasePage',{attrs:{"title":"Pricing","subtitle":"Choose the plan that's right for you or your business.","img":require('@/assets/mapwithmarkers.jpg')},on:{"finish":_vm.finish}},[_c('Tiers')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }